import { InlineMessage } from '@volvo/vcdk-react';
import React, { useState } from 'react';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

type Props = React.ComponentProps<typeof InlineMessage> & {
  storageKey: string;
  children?: React.ReactNode;
  actions?: React.ReactNode;
};

type InformationWithCtaContentProps = Omit<Props, 'storageKey'> & {
  storageKey: string;
};

const InformationWithCtaContent: React.FC<InformationWithCtaContentProps> = ({
  children,
  actions,
  storageKey,
  ...props
}) => {
  const [isClosed, setIsClosed] = useState(() => {
    return localStorage.getItem(storageKey) === 'true';
  });

  const handleClose = () => {
    localStorage.setItem(storageKey, 'true');
    setIsClosed(true);
  };

  if (isClosed) {
    return null;
  }

  return (
    <InlineMessage onClose={handleClose} {...props}>
      {children}
      {actions && <div className="mt-6 flex flex-row gap-4">{actions}</div>}
    </InlineMessage>
  );
};

const InformationWithCta: React.FC<Props> = ({ storageKey, ...props }) => {
  // Re-mount when key changes so state is re-initialized from matching localStorage entry.
  return <InformationWithCtaContent key={storageKey} storageKey={storageKey} {...props} />;
};

export default withComponentErrorBoundary(InformationWithCta);
